import { useEffect, useState } from 'react';

import { CoachPerformanceData } from '../../../../interfaces/entity-dashboard/CoachPerformanceData';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';

type UseCoachPerformanceDataParams = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

type UseCoachPerformanceDataReturn = {
  coachPerformanceItems: CoachPerformanceData[] | null;
};

const COACH_ITEMS_COUNT = 4;

export const useCoachPerformanceData = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseCoachPerformanceDataParams): UseCoachPerformanceDataReturn => {
  const [coachPerformanceItems, setCoachPerformanceItems] = useState<
    CoachPerformanceData[] | null
  >(null);

  const fetchCoachPerformanceData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getCoachPerformanceData({
      ...dateRange,
      solutionType: solutionTypeFilter,
      itemCount: COACH_ITEMS_COUNT,
    });

    setCoachPerformanceItems(data.coachPerformance);
  };

  useEffect(() => {
    fetchCoachPerformanceData();
  }, [dateRangePreset, solutionTypeFilter]);

  return { coachPerformanceItems };
};
